<template>
  <div>
    <CRow>
      <CModal
        :show.sync="modal_data_baixa"
        color="warning"
        title="Excluir as consultas criadas após a data de baixa ?"
      >
        <div>
          <CButton color="success" class="m-2" @click="excluirConsultas()"
            >Sim</CButton
          >
          <CButton color="info" class="m-2" @click="modal_data_baixa = false"
            >Não</CButton
          >
        </div>
      </CModal>
      <CCol>
        <CCard>
          <CCardBody>
            <CForm>
              <CTabs>
                <CTab>
                  <template slot="title">
                    <CIcon name="cil-bookmark" /> Dados de Cadastro
                  </template>
                  <br />
                  <CAlert
                    color="danger"
                    id="aviso"
                    name="aviso"
                    :show.sync="validacoes.aviso"
                    closeButton
                    >{{ this.validacoes.msg }}</CAlert
                  >
                  <CAlert
                    color="success"
                    id="aviso"
                    name="sucesso"
                    :show.sync="validacoes.sucesso"
                    closeButton
                    >{{ this.validacoes.msg }}</CAlert
                  >

                  <CModal
                    :show.sync="showModalStatus"
                    title="Aviso"
                    color="warning"
                  >
                    <CAlert
                      :color="color"
                      id="aviso"
                      name="aviso"
                      :show.sync="alerta"
                      closeButton
                      >{{ this.mensagem }}</CAlert
                    >
                    <h3>Confirme a ação !</h3>
                    <CButton
                      v-show="!showerror && this.typeUser != 2"
                      color="success"
                      class="m-2"
                      @click="atualizarStatus()"
                      >Atualizar</CButton
                    >
                  </CModal>
                  <CInput
                    v-model="paciente.patient"
                    prepend="NOME"
                    invalid-feedback="Nome é obrigatório"
                  >
                    <template #append-content>
                      <CIcon name="cil-badge" />
                    </template>
                  </CInput>
                  <CInput
                    v-model="paciente.social_name"
                    prepend="NOME SOCIAL"
                    required
                    invalid-feedback="* Campo obrigatório"
                  >
                    <template #append-content>
                      <CIcon name="cil-badge" />
                    </template>
                  </CInput>
                  <CInput
                    v-model="paciente.cpf"
                    prepend="CPF"
                    autocomplete="nome"
                    invalid-feedback="CPF é obrigatório"
                    v-mask="cpf"
                    @change="validarCPF"
                  >
                    <template #append-content>
                      <CIcon name="cil-bank" />
                    </template>
                  </CInput>
                  <CInput
                    v-model="paciente.date_birth"
                    prepend="D.NASCIMENTO"
                    type="date"
                    autocomplete="nome"
                  >
                    <template #append-content>
                      <CIcon name="cil-bank" />
                    </template>
                  </CInput>
                  <span v-if="alertaProfissional" class="text-red"
                    >Selecione o profissional</span
                  >
                  <CSelect
                    :options="profissionais"
                    :value.sync="paciente.id_professional"
                    prepend="PROFISSIONAL"
                    autocomplete="Cidade"
                    invalid-feedback="* Campo obrigatório"
                  >
                    <template #append-content>
                      <CIcon name="cil-contact" />
                    </template>
                  </CSelect>
                  <CInput
                    v-model="paciente.email"
                    prepend="EMAIL"
                    autocomplete="email"
                    invalid-feedback="Email é obrigatório"
                  >
                    <template #append-content>
                      <CIcon name="cil-at" />
                    </template>
                  </CInput>
                  <CInput
                    v-model="paciente.phone"
                    prepend="TELEFONE"
                    invalid-feedback="Telefone Contato é obrigatório"
                    v-mask="telefone"
                  >
                    <template #append-content>
                      <CIcon name="cil-phone" />
                    </template>
                  </CInput>

                  <CSelect
                    :options="estados"
                    @change="listcities()"
                    v-model="paciente.uf"
                    :value.sync="paciente.uf"
                    prepend="UF"
                  >
                    <template #append-content>
                      <CIcon name="cil-contact" />
                    </template>
                  </CSelect>

                  <CSelect
                    :options="cidades"
                    v-model="paciente.city"
                    prepend="CIDADE"
                    autocomplete="Cidade"
                    invalid-feedback="* Campo obrigatório"
                  >
                    <template #append-content>
                      <CIcon name="cil-contact" />
                    </template>
                  </CSelect>

                  <CInput
                    v-model="paciente.address"
                    prepend="ENDEREÇO"
                    autocomplete="endereço"
                    invalid-feedback="Endereco obrigatorio"
                  >
                    <template #append-content>
                      <CIcon name="cil-contact" />
                    </template>
                  </CInput>
                  <CInput
                    v-model="paciente.numero"
                    prepend="NÚMERO"
                    autocomplete="endereço"
                    invalid-feedback="* Campo obrigatório"
                  >
                    <template #append-content>
                      <CIcon name="cil-contact" />
                    </template>
                  </CInput>
                  <CSelect
                    :options="convenios"
                    :value.sync="paciente.insurance"
                    v-model="paciente.insurance"
                    prepend="CONVENIO"
                    autocomplete="complemento"
                    invalid-feedback="Convenio obrigatorio"
                  >
                    <template #append-content>
                      <CIcon name="cil-contact" />
                    </template>
                  </CSelect>
                  <CInput
                    v-model="paciente.n_card"
                    prepend="Nº CARTEIRINHA"
                    autocomplete="endereço"
                    invalid-feedback="* Campo obrigatório"
                  />
                  <template #append-content>
                    <CIcon name="cil-contact" />
                  </template>
                  <CInput
                    v-model="paciente.bairro"
                    prepend="BAIRRO"
                    autocomplete="bairro"
                    invalid-feedback="Bairro obrigatorio"
                  >
                    <template #append-content>
                      <CIcon name="cil-contact" />
                    </template>
                  </CInput>
                  <CInput
                    v-model="paciente.cep"
                    prepend="CEP"
                    autocomplete="cep"
                    invalid-feedback="Cep obrigatorio"
                    v-mask="cep"
                  >
                    <template #append-content>
                      <CIcon name="cil-contact" />
                    </template>
                  </CInput>
                  <CInput
                    type="date"
                    v-model="paciente.sick_leave"
                    prepend="DATA BAIXA"
                    @blur="mudaDataBaixa()"
                  >
                    <template #append-content>
                      <CIcon name="cil-contact" />
                    </template>
                  </CInput>
                  <CSelect
                    v-show="this.typeUser == 1"
                    :options="optionStatus"
                    :value.sync="paciente.status"
                    v-model="paciente.status"
                    prepend="STATUS"
                    @change="changeStatus()"
                  >
                    <template #append-content>
                      <CIcon name="cil-contact" />
                    </template>
                  </CSelect>
                  <section class="radios-nf">
                    <div>PACIENTE NF:</div>
                    <div>
                      <input
                        type="radio"
                        id="um"
                        value="SIM"
                        v-model="paciente.nf"
                      />
                      <label for="um" class="radios-nf-check">SIM</label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        id="dois"
                        value="NAO"
                        v-model="paciente.nf"
                      />
                      <label for="dois" class="radios-nf-check">NÃO</label>
                    </div>
                  </section>
                  <CButton
                    v-show="!showerror && this.typeUser != 2"
                    color="success"
                    class="m-2"
                    @click="atualizarPaciente()"
                    >Atualizar</CButton
                  >
                  <CButton color="info" class="m-2" @click="voltar()"
                    >Voltar</CButton
                  >

                  <CButton
                    v-show="showerror == true"
                    color="success"
                    class="m-2"
                    @click="send()"
                    >Atualizar Integração</CButton
                  >
                </CTab>
                <CTab v-if="typeUser != 3 && typeUser != 1">
                  <template slot="title">
                    <CIcon name="cil-bookmark" /> Evolução
                  </template>
                  <CCard>
                    <CCardBody class="card-caroucel">
                      <!-- <CCarousel indicators arrows animate height="600px">
                        <div
                          v-for="(item, index) in imagensEvolucao"
                          :key="index"
                        >
                          <div v-if="item.type == 'img'">
                            <CCarouselItem
                            id="imagem_evolucao"
                            v-for="(base64Item, base64Index) in item.base64"
                            :key="base64Index"
                            :captionHeader="item.data"
                            :image="base64Item"
                            :captionText="item.hora"
                          />
                          </div>
                        </div>
                      </CCarousel> -->
                      <div>
                        <div v-if="imagensEvolucao.length === 0">
                          <p>Não há evolução disponível.</p>
                        </div>
                        <div v-else>
                          <CCarousel indicators arrows animate height="600px">
                            <div
                              v-for="(item, index) in imagensEvolucao"
                              :key="index"
                            >
                              <div v-if="item.type === 'img'">
                                <CCarouselItem
                                  id="imagem_evolucao"
                                  v-for="(base64Item,
                                  base64Index) in item.base64"
                                  :key="base64Index"
                                  :captionHeader="item.data"
                                  :image="base64Item"
                                  :captionText="item.hora"
                                />
                              </div>
                              <div v-else>
                                <CCarouselItem
                                  id="imagem_placeholder"
                                  :key="'placeholder_' + index"
                                  :captionHeader="item.data"
                                  :image="{ placeholderColor: 'grey' }"
                                  :captionText="item.base64"
                                />
                              </div>
                            </div>
                          </CCarousel>
                        </div>
                      </div>
                    </CCardBody>
                  </CCard>
                </CTab>
              </CTabs>
              <CAlert
                color="danger"
                id="aviso"
                name="aviso"
                :show.sync="validacoes.aviso"
                closeButton
                >{{ this.validacoes.msg }}</CAlert
              >
              <CAlert
                color="success"
                id="aviso"
                name="sucesso"
                :show.sync="validacoes.sucessoNf"
                closeButton
                >{{ this.validacoes.msg }}</CAlert
              >

              <CAlert
                color="success"
                id="aviso"
                name="sucesso"
                :show.sync="validacoes.sucesso"
                closeButton
                >{{ this.validacoes.msg }}</CAlert
              >
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import moment from "moment";
export default {
  name: "PerfilClube",
  data() {
    return {
      hover: true,
      striped: true,
      bordered: false,
      small: true,
      fixed: true,
      dark: false,
      cpf: "###.###.###-##",
      telefone: "(##) #####.####",
      cep: "#####-###",
      sucesso: false,
      items: [],
      validacoes: {
        sucesso: false,
        aviso: false,
        msg: "",
        ifs: false,
        sucessoNf: false,
      },
      listInsurance: [],
      convenios: [],
      estados: [],
      cidades: [],

      paciente: {
        uf: "RS",
        patient: "",
        cpf: "",
        date_birth: "1993-06-16",
        social_name: "",
        id_convenio: "",
        address: "",
        email: "",
        city: "",
        id_professional: "",
        insurance: "",
        phone: "",
        bairro: "",
        cep: "",
        id: "",
        nf: "",
        n_card: "",
        sick_leave: null,
        status: "",
        numero:""
      },
      valorAnteriorSick_leave: null,
      showerror: false,
      from: "",
      queryParams: {},
      consulta: "",
      profissionais: [],
      alertaProfissional: false,
      typeUser: "",
      modal_data_baixa: false,
      imagensEvolucao: [],
      optionStatus: [
        {
          label: "ADIMPLENTE",
          value: "ADIMPLENTE",
        },
        {
          label: "INADIMPLENTE",
          value: "INADIMPLENTE",
        },
      ],
      showModalStatus: false,
      alerta: false,
      mensagem: "",
      color: "",
    };
  },
  methods: {
    voltar() {
      if (this.from == "error") {
        this.$router.push("./integration/patients");
      } else {
        this.$router.push("./pacientes");
      }
    },
    listaInsurance() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}convenios`)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((item) => {
            if (item.name != "Coparticipação Saúde Pas") {
              this.convenios.push({
                label: item.name,
                value: item.id,
              });
            }
          });
        })
        .then((res) => {});
    },
    listarPacientes() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}pacientes`)
        .then((res) => res.json())
        .then((res) => {
          this.items = res;
        });
    },
    listarDadosPaciente(id) {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}pacientes/${id}`)
        .then((res) => res.json())
        .then((res) => {
          this.paciente = res[0];
          this.paciente.numero = res[0].number
          this.paciente.date_birth = moment
            .utc(this.paciente.date_birth)
            .format("YYYY-MM-DD");

          this.paciente.sick_leave = this.paciente.sick_leave
            ? moment.utc(this.paciente.sick_leave).format("YYYY-MM-DD")
            : null;
          this.valorAnteriorSick_leave = this.paciente.sick_leave;

          if (!this.paciente.id_professional) {
            this.alertaProfissional = true;
          }

          if (!res[0].uf) {
            this.paciente.uf = "RS";
          }
        });
    },
    converterMaiuscula(string) {
      const substring = string
        .toLowerCase()
        .replace(/(?:^|\s)\S/g, function(p) {
          return p.toUpperCase();
        });
      return substring;
    },
    validarCPF() {
      this.items.forEach((item) => {
        if (this.paciente.cpf === item.cpf) {
          this.paciente.cpf = "";
          this.validacoes.aviso = true;
          this.validacoes.msg =
            "CPF inválido, já existe um cadastro com este CPF";
          setTimeout(() => {
            this.validacoes.aviso = false;
          }, 3000);
        }
      });
    },
    atualizar() {
      this.$http
        .post(
          `${process.env.VUE_APP_API_BASE_URL}pacientes/atualizar`,
          this.paciente
        )
        .then((res) => {
          this.sucesso = true;
          if (this.paciente.id_professional != null) {
            this.alertaProfissional = false;
          } else {
            this.alertaProfissional = true;
          }
        });
    },
    //validar campos com msg's
    validarCampos() {
      const verificarCamposVazio = {
        paciente: !this.paciente.patient,
        cpf: !this.paciente.cpf,
        email: !this.paciente.email,
        telefone: !this.paciente.phone,
        cidade: !this.paciente.city,
        endereço: !this.paciente.address,
        convênio: !this.paciente.insurance,
        bairro: !this.paciente.bairro,
        cep: !this.paciente.cep,
        nf: !this.paciente.nf,
      };

      for (const [key, value] of Object.entries(verificarCamposVazio)) {
        if (value) {
          this.validacoes.aviso = true;
          this.validacoes.msg = `${key.charAt(0).toUpperCase() +
            key.slice(1)} do paciente precisa ser preenchido`;
          return;
        }
      }

      this.validacoes.ifs = true;
    },

    atualizarPaciente() {
      this.validarCampos();
      let arrDadosPaciente = Object.values(this.paciente);
      let validacao = false;
      let expEmail = /[^\n]+@\S+\.\S+/;

      arrDadosPaciente.forEach((item) => {
        if (item === "") {
          validacao = true;
        }
      });
      if (this.validacoes.ifs) {
        if (this.paciente.cpf.length == 14) {
          if (expEmail.test(this.paciente.email)) {
            this.atualizar();
            this.validacoes.sucesso = true;
            this.validacoes.msg = "Cadastro efetuado com sucesso";
            setTimeout(() => {
              this.validacoes.sucesso = false;
            }, 500);
          } else {
            this.validacoes.aviso = true;
            this.validacoes.msg = "Endereço de email inválido.";
            this.paciente.email = "";
            setTimeout(() => {
              this.validacoes.aviso = false;
            }, 3000);
          }
        } else {
          this.validacoes.aviso = true;
          this.validacoes.msg =
            "CPF inválido, quantidade de caracteres deve conter 11 digitos";
          this.paciente.cpf = "";
          setTimeout(() => {
            this.validacoes.aviso = false;
          }, 3000);
        }
      }
    },
    listStates() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}estados`)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((item) => {
            this.estados.push({
              label: item.abbreviation,
              value: item.abbreviation,
            });
          });
        });
    },
    listcities() {
      this.cidades = [];
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}cidades/${this.paciente.uf}`)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((item) => {
            this.cidades.push({
              label: item.name,
              value: item.name,
            });
          });
        });
    },
    send() {
      this.$http
        .post(
          `${process.env.VUE_APP_API_BASE_URL}integrations/patients`,
          this.paciente
        )
        .then((res) => {
          this.validacoes.sucesso = true;
          this.validacoes.msg = "Paciente atualizado com sucesso";
          this.atualizarPaciente();
          setTimeout(() => {
            this.validacoes.sucesso = false;
          }, 4000);

          if (this.queryParams.typeError == "consult") {
            //get consulta id
            this.$http
              .get(
                `${process.env.VUE_APP_API_BASE_URL}consultas/${this.queryParams.idConsulta}`
              )
              .then((res) => res.json())
              .then((res) => {
                res[1] = this.paciente;
                this.$http
                  .post(
                    `${process.env.VUE_APP_API_BASE_URL}integrations/consult`,
                    { ...res }
                  )
                  .then((res) => {
                    //modal de sucesso caso status 200

                    this.validacoes.sucessoNf = true;
                    this.validacoes.msg = "Nota fiscal atualizada com sucesso";
                    setTimeout(() => {
                      this.validacoes.sucessoNf = false;
                    }, 5000);
                  });
              });
          }
        })
        .catch((err) => {
          if (err.status == 400) {
            this.validacoes.aviso = true;
            this.validacoes.msg = err.body[0].erro;
            setTimeout(() => {
              this.validacoes.aviso = false;
            }, 4000);
          } else {
            this.validacoes.aviso = true;
            this.validacoes.msg = "Cpf é campo obrigatorio";
            setTimeout(() => {
              this.validacoes.aviso = false;
            }, 2000);
          }
        });
    },
    listarProfissionais() {
      this.$http
        .get(process.env.VUE_APP_API_BASE_URL + "profissionais-lista")
        .then((res) => res.json())
        .then((payload) => {
          payload.forEach((elem) => {
            elem.name = elem.name
              .split(" ")
              .map(
                (nome) =>
                  nome.charAt(0).toUpperCase() + nome.slice(1).toLowerCase()
              )
              .join(" ");
          });
          payload.sort((a, b) => {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            return 0;
          });
          this.profissionais = payload.map((x) => {
            return {
              label: x.name,
              value: x.id,
            };
          });

          this.profissionais.unshift({
            label: "",
            value: null,
          });
        });
    },
    excluirConsultas() {
      this.$http
        .post(
          `${process.env.VUE_APP_API_BASE_URL}consultas/excluir/databaixa/${this.paciente.id}`,
          {
            data: this.paciente.sick_leave,
          }
        )
        .then(() => {
          this.modal_data_baixa = false;
        });
    },
    mudaDataBaixa() {
      this.$http
        .get(
          `${process.env.VUE_APP_API_BASE_URL}data-baixa/${this.paciente.id}`
        )
        .then((res) => res.json())
        .then((res) => {
          this.valorAnteriorSick_leave = res[0].sick_leave;
          if (
            this.valorAnteriorSick_leave == null &&
            this.paciente.sick_leave !== null
          ) {
            // Valor anterior era nulo e o valor atual não é nulo
            this.modal_data_baixa = true;
          } else {
            this.modal_data_baixa = false;
          }

          this.valorAnteriorSick_leave = this.paciente.sick_leave;
        });
    },
    listarConsultasPcientes() {
      let id = this.$route.query.id;
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}paciente/evolucao/${id}`)
        .then((res) => res.json())
        .then((res) => {
          console.log({ res })
          this.imagensEvolucao = res;
          this.imagensEvolucao.forEach((elem) => {
            elem.data = moment.utc(elem.data).format("DD/MM/YYYY");
          });
          
        });
    },
    changeStatus(event) {
      
      this.showModalStatus = true;
    },
    atualizarStatus() {
      this.$http
        .post(
          `${process.env.VUE_APP_API_BASE_URL}pacientes/status/${this.paciente.id}`,
          { status: this.paciente.status }
        )
        .then((res) => {
          this.alerta = true;
          this.mensagem = "Paciente atualizado";
          this.color = "success";

          setTimeout(() => {
            this.alerta = false;
            this.showModalStatus = false;
          }, 3000);
        });
    },
  },

  mounted() {
    let id = this.$route.query.id;
    this.from = this.$route.query.from;
    this.queryParams = this.$route.query;
    if (this.from == "error") {
      this.showerror = true;
    }

    this.typeUser = localStorage.getItem("type");
    console.log(this.typeUser)
    this.listarDadosPaciente(id);
    this.listaInsurance();
    this.listarPacientes();
    this.listStates();
    this.listcities();
    this.listarProfissionais();
    this.listarConsultasPcientes();
  },
};
</script>
<style scoped>
.radios-nf {
  color: #788393;
  display: grid;
  grid-template-columns: 100px 70px 1fr;
  height: 40px;
}

.radios-nf-check {
  margin-left: 10px;
}
.text-red {
  color: #d60707;
}
#imagem_evolucao {
  height: 600px;
  width: 450px;
}
.card-caroucel {
  background-color: #e3e3e3;
}
#imagem_placeholder {
  height: 400px !important;
}
</style>
